<div class="tab-pane fade show active">
	<p-table
		[value]="notficationsLogs"
		[rows]="notficationsLogs?.length"
		class="noBorder-table"
		styleClass="p-datatable-striped"
		[rowHover]="true"
		[showCurrentPageReport]="true"
		[autoLayout]="true"
		[loading]="false"
		[metaKeySelection]="true"
		[columns]="columns"
		dataKey="id"
	>
		<!-- TABLE COLUMN DEFINITION -->
		<ng-template pTemplate="header" let-columns> 
			<!-- HEADERS -->

			<tr style="white-space: nowrap">
				<!-- GENERAL INFORMATION HEADERS -->
				<th
					[pSortableColumn]="column.field"
					[virtualScroll]="true"
					[ngClass]="{
						'large-column': column.largeColumn
					}"
					*ngFor="let column of columns"
 				>
					<div  class="d-flex align-items-center h-100">
						<!-- COLUMN TITLE -->
						<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
							{{ column.header }}
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" let-notificationLog>
			<tr
				style="white-space: nowrap"
				class="p-selectable-row custom-rows"
			 
			>
				<td>
					<div class="d-flex justify-content-center">
						{{ 'administration.customers.notification.' + notificationLog.type | translate }}
					</div>
				</td>
				<td>
					<div class="d-flex justify-content-center">
						{{ notificationLog.sendingDate | date : 'dd/MM/yyyy HH:mm:ss' }}
					</div>
				</td>
				<td>
					<div class="d-flex justify-content-center">
						<i
							pTooltip="{{notificationLog.mailReceiver}}"
							tooltipPosition="top"
							class="pi"
							[ngClass]="{
								'true-icon pi-check-circle': notificationLog.mailReceiver,
								'false-icon pi-times-circle': !notificationLog.mailReceiver
							}"
							[ngStyle]="{
								color: notificationLog.mailReceiver ? 'green' : 'red'
							}"
							style="font-size: 1.5rem;  "
						></i>
					</div>
				</td>
				<td>
					<div class="d-flex justify-content-center">
						<i
							class="pi"
							[ngClass]="{
								'true-icon pi-check-circle': notificationLog.smsReceiver,
								'false-icon pi-times-circle': !notificationLog.smsReceiver
							}"
							pTooltip="{{notificationLog.smsReceiver}}"
							tooltipPosition="top"
							[ngStyle]="{
								color: notificationLog.smsReceiver ? 'green' : 'red'
							}"
							style="font-size: 1.5rem; "
						></i>
					</div>
				</td>
			</tr>
		</ng-template>
		<!-- TABLE EMPTY MESSAGE -->
		<ng-template pTemplate="emptymessage">
			<tr>
				<td colspan="100" class="p-0">
					<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-orders-message" i18n>
						{{ 'table.tableEmptyMessage' | translate }}!
					</div>
				</td>
			</tr>
		</ng-template>

		<!-- FOOTER -->

		<ng-template pTemplate="footer"> </ng-template>
	</p-table>
</div>
